/*! AtatusJs - v3.1.1 - 2018-07-11
* Copyright (c) 2018 Atatus */
!function (a) {
  function b(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
  }

  function c(a) {
    return "undefined" == typeof a;
  }

  if (a) {
    var d = {},
        e = a.TraceKit,
        f = [].slice,
        g = "?";
    d.noConflict = function () {
      return a.TraceKit = e, d;
    }, d.wrap = function (a) {
      function b() {
        try {
          return a.apply(this, arguments);
        } catch (b) {
          throw d.report(b), b;
        }
      }

      return b;
    }, d.report = function () {
      function c(a) {
        h(), m.push(a);
      }

      function e(a) {
        for (var b = m.length - 1; b >= 0; --b) {
          m[b] === a && m.splice(b, 1);
        }
      }

      function f(a, c, e) {
        var f = null;

        if (!c || d.collectWindowErrors) {
          for (var g in m) {
            if (b(m, g)) try {
              m[g](a, c, e);
            } catch (h) {
              f = h;
            }
          }

          if (f) throw f;
        }
      }

      function g(a, b, c, e, g) {
        var h = null;
        if (o) d.computeStackTrace.augmentStackTraceWithInitialElement(o, b, c, a), i();else if (g) h = d.computeStackTrace(g), f(h, !0, g);else {
          var j = {
            url: b,
            line: c,
            column: e
          };
          j.func = d.computeStackTrace.guessFunctionName(j.url, j.line), j.context = d.computeStackTrace.gatherContext(j.url, j.line), h = {
            mode: "onerror",
            message: a,
            stack: [j]
          }, f(h, !0, null);
        }
        return k ? k.apply(this, arguments) : !1;
      }

      function h() {
        l !== !0 && (k = a.onerror, a.onerror = g, l = !0);
      }

      function i() {
        var a = o,
            b = n;
        o = null, n = null, f(a, !1, b);
      }

      function j(b) {
        if (o) {
          if (n === b) return;
          i();
        }

        var c = d.computeStackTrace(b);
        throw o = c, n = b, a.setTimeout(function () {
          n === b && i();
        }, c.incomplete ? 2e3 : 0), b;
      }

      var k,
          l,
          m = [],
          n = null,
          o = null;
      return j.subscribe = c, j.unsubscribe = e, j;
    }(), d.computeStackTrace = function () {
      function e(a) {
        return "string" != typeof a ? [] : "";
      }

      function f(c) {
        if ("string" != typeof c) return [];

        if (!b(w, c)) {
          var d = "",
              f = "";

          try {
            f = a.document.domain;
          } catch (g) {}

          var h = /(.*)\:\/\/([^:\/]+)([:\d]*)\/{0,1}([\s\S]*)/.exec(c);
          h && h[2] === f && (d = e(c)), w[c] = d ? d.split("\n") : [];
        }

        return w[c];
      }

      function h(a, b) {
        var d,
            e = /function ([^(]*)\(([^)]*)\)/,
            h = /['"]?([0-9A-Za-z$_]+)['"]?\s*[:=]\s*(function|eval|new Function)/,
            i = "",
            j = 10,
            k = f(a);
        if (!k.length) return g;

        for (var l = 0; j > l; ++l) {
          if (i = k[b - l] + i, !c(i)) {
            if (d = h.exec(i)) return d[1];
            if (d = e.exec(i)) return d[1];
          }
        }

        return g;
      }

      function i(a, b) {
        var e = f(a);
        if (!e.length) return null;
        var g = [],
            h = Math.floor(d.linesOfContext / 2),
            i = h + d.linesOfContext % 2,
            j = Math.max(0, b - h - 1),
            k = Math.min(e.length, b + i - 1);
        b -= 1;

        for (var l = j; k > l; ++l) {
          c(e[l]) || g.push(e[l]);
        }

        return g.length > 0 ? g : null;
      }

      function j(a) {
        return a.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, "\\$&");
      }

      function k(a) {
        return j(a).replace("<", "(?:<|&lt;)").replace(">", "(?:>|&gt;)").replace("&", "(?:&|&amp;)").replace('"', '(?:"|&quot;)').replace(/\s+/g, "\\s+");
      }

      function l(a, b) {
        for (var c, d, e = 0, g = b.length; g > e; ++e) {
          if ((c = f(b[e])).length && (c = c.join("\n"), d = a.exec(c))) return {
            url: b[e],
            line: c.substring(0, d.index).split("\n").length,
            column: d.index - c.lastIndexOf("\n", d.index) - 1
          };
        }

        return null;
      }

      function m(a, b, c) {
        var d,
            e = f(b),
            g = new RegExp("\\b" + j(a) + "\\b");
        return c -= 1, e && e.length > c && (d = g.exec(e[c])) ? d.index : null;
      }

      function n(b) {
        if (!c(a && a.document)) {
          for (var d, e, f, g, h = [a.location.href], i = a.document.getElementsByTagName("script"), m = "" + b, n = /^function(?:\s+([\w$]+))?\s*\(([\w\s,]*)\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/, o = /^function on([\w$]+)\s*\(event\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/, p = 0; p < i.length; ++p) {
            var q = i[p];
            q.src && h.push(q.src);
          }

          if (f = n.exec(m)) {
            var r = f[1] ? "\\s+" + f[1] : "",
                s = f[2].split(",").join("\\s*,\\s*");
            d = j(f[3]).replace(/;$/, ";?"), e = new RegExp("function" + r + "\\s*\\(\\s*" + s + "\\s*\\)\\s*{\\s*" + d + "\\s*}");
          } else e = new RegExp(j(m).replace(/\s+/g, "\\s+"));

          if (g = l(e, h)) return g;

          if (f = o.exec(m)) {
            var t = f[1];
            if (d = k(f[2]), e = new RegExp("on" + t + "=[\\'\"]\\s*" + d + "\\s*[\\'\"]", "i"), g = l(e, h[0])) return g;
            if (e = new RegExp(d), g = l(e, h)) return g;
          }

          return null;
        }
      }

      function o(a) {
        if (!a.stack) return null;

        for (var b, d, e = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|webpack|eval).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, f = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i, j = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i, k = a.stack.split("\n"), l = [], n = /^(.*) is undefined$/.exec(a.message), o = 0, p = k.length; p > o; ++o) {
          if (b = e.exec(k[o])) {
            var q = b[2] && -1 !== b[2].indexOf("native");
            d = {
              url: q ? null : b[2],
              func: b[1] || g,
              args: q ? [b[2]] : [],
              line: b[3] ? +b[3] : null,
              column: b[4] ? +b[4] : null
            };
          } else if (b = j.exec(k[o])) d = {
            url: b[2],
            func: b[1] || g,
            args: [],
            line: +b[3],
            column: b[4] ? +b[4] : null
          };else {
            if (!(b = f.exec(k[o]))) continue;
            d = {
              url: b[3],
              func: b[1] || g,
              args: b[2] ? b[2].split(",") : [],
              line: b[4] ? +b[4] : null,
              column: b[5] ? +b[5] : null
            };
          }

          !d.func && d.line && (d.func = h(d.url, d.line)), d.line && (d.context = i(d.url, d.line)), l.push(d);
        }

        return l.length ? (l[0] && l[0].line && !l[0].column && n ? l[0].column = m(n[1], l[0].url, l[0].line) : l[0].column || c(a.columnNumber) || (l[0].column = a.columnNumber + 1), {
          mode: "stack",
          name: a.name,
          message: a.message,
          stack: l
        }) : null;
      }

      function p(a) {
        var b = a.stacktrace;

        if (b) {
          for (var c, d = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i, e = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\))? in (.*):\s*$/i, f = b.split("\n"), g = [], j = 0; j < f.length; j += 2) {
            var k = null;

            if ((c = d.exec(f[j])) ? k = {
              url: c[2],
              line: +c[1],
              column: null,
              func: c[3],
              args: []
            } : (c = e.exec(f[j])) && (k = {
              url: c[6],
              line: +c[1],
              column: +c[2],
              func: c[3] || c[4],
              args: c[5] ? c[5].split(",") : []
            }), k) {
              if (!k.func && k.line && (k.func = h(k.url, k.line)), k.line) try {
                k.context = i(k.url, k.line);
              } catch (l) {}
              k.context || (k.context = [f[j + 1]]), g.push(k);
            }
          }

          return g.length ? {
            mode: "stacktrace",
            name: a.name,
            message: a.message,
            stack: g
          } : null;
        }
      }

      function q(c) {
        var d = c.message.split("\n");
        if (d.length < 4) return null;
        var e,
            g = /^\s*Line (\d+) of linked script ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i,
            j = /^\s*Line (\d+) of inline#(\d+) script in ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i,
            m = /^\s*Line (\d+) of function script\s*$/i,
            n = [],
            o = a && a.document && a.document.getElementsByTagName("script"),
            p = [];

        for (var q in o) {
          b(o, q) && !o[q].src && p.push(o[q]);
        }

        for (var r = 2; r < d.length; r += 2) {
          var s = null;
          if (e = g.exec(d[r])) s = {
            url: e[2],
            func: e[3],
            args: [],
            line: +e[1],
            column: null
          };else if (e = j.exec(d[r])) {
            s = {
              url: e[3],
              func: e[4],
              args: [],
              line: +e[1],
              column: null
            };
            var t = +e[1],
                u = p[e[2] - 1];

            if (u) {
              var v = f(s.url);

              if (v) {
                v = v.join("\n");
                var w = v.indexOf(u.innerText);
                w >= 0 && (s.line = t + v.substring(0, w).split("\n").length);
              }
            }
          } else if (e = m.exec(d[r])) {
            var x = a.location.href.replace(/#.*$/, ""),
                y = new RegExp(k(d[r + 1])),
                z = l(y, [x]);
            s = {
              url: x,
              func: "",
              args: [],
              line: z ? z.line : e[1],
              column: null
            };
          }

          if (s) {
            s.func || (s.func = h(s.url, s.line));
            var A = i(s.url, s.line),
                B = A ? A[Math.floor(A.length / 2)] : null;
            s.context = A && B.replace(/^\s*/, "") === d[r + 1].replace(/^\s*/, "") ? A : [d[r + 1]], n.push(s);
          }
        }

        return n.length ? {
          mode: "multiline",
          name: c.name,
          message: d[0],
          stack: n
        } : null;
      }

      function r(a, b, c, d) {
        var e = {
          url: b,
          line: c
        };

        if (e.url && e.line) {
          a.incomplete = !1, e.func || (e.func = h(e.url, e.line)), e.context || (e.context = i(e.url, e.line));
          var f = / '([^']+)' /.exec(d);

          if (f && (e.column = m(f[1], e.url, e.line)), a.stack.length > 0 && a.stack[0].url === e.url) {
            if (a.stack[0].line === e.line) return !1;
            if (!a.stack[0].line && a.stack[0].func === e.func) return a.stack[0].line = e.line, a.stack[0].context = e.context, !1;
          }

          return a.stack.unshift(e), a.partial = !0, !0;
        }

        return a.incomplete = !0, !1;
      }

      function s(a, b) {
        for (var c, e, f, i = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i, j = [], k = {}, l = !1, o = s.caller; o && !l; o = o.caller) {
          if (o !== t && o !== d.report) {
            if (e = {
              url: null,
              func: g,
              args: [],
              line: null,
              column: null
            }, o.name ? e.func = o.name : (c = i.exec(o.toString())) && (e.func = c[1]), "undefined" == typeof e.func) try {
              e.func = c.input.substring(0, c.input.indexOf("{"));
            } catch (p) {}

            if (f = n(o)) {
              e.url = f.url, e.line = f.line, e.func === g && (e.func = h(e.url, e.line));
              var q = / '([^']+)' /.exec(a.message || a.description);
              q && (e.column = m(q[1], f.url, f.line));
            }

            k["" + o] ? l = !0 : k["" + o] = !0, j.push(e);
          }
        }

        b && j.splice(0, b);
        var u = {
          mode: "callers",
          name: a.name,
          message: a.message,
          stack: j
        };
        return r(u, a.sourceURL || a.fileName, a.line || a.lineNumber, a.message || a.description), u;
      }

      function t(a, b) {
        var c = null;
        b = null == b ? 0 : +b;

        try {
          if (c = p(a)) return c;
        } catch (d) {
          if (v) throw d;
        }

        try {
          if (c = o(a)) return c;
        } catch (d) {
          if (v) throw d;
        }

        try {
          if (c = q(a)) return c;
        } catch (d) {
          if (v) throw d;
        }

        try {
          if (c = s(a, b + 1)) return c;
        } catch (d) {
          if (v) throw d;
        }

        return {
          mode: "failed"
        };
      }

      function u(a) {
        a = (null == a ? 0 : +a) + 1;

        try {
          throw new Error();
        } catch (b) {
          return t(b, a + 1);
        }
      }

      var v = !1,
          w = {};
      return t.augmentStackTraceWithInitialElement = r, t.guessFunctionName = h, t.gatherContext = i, t.ofCaller = u, t.getSource = f, t;
    }(), d.extendToAsynchronousCallbacks = function () {
      var b = function b(_b) {
        var c = a[_b];

        a[_b] = function () {
          var a = f.call(arguments),
              b = a[0];
          return "function" == typeof b && (a[0] = d.wrap(b)), c.apply ? c.apply(this, a) : c(a[0], a[1]);
        };
      };

      b("setTimeout"), b("setInterval");
    }, d.remoteFetching || (d.remoteFetching = !0), d.collectWindowErrors || (d.collectWindowErrors = !0), (!d.linesOfContext || d.linesOfContext < 1) && (d.linesOfContext = 11), a.TraceKit = d;
  }
}("undefined" != typeof window ? window : global), function (a, b) {
  "use strict";

  if (a && a.event && a.event.add) {
    var c = a.event.add;

    a.event.add = function (d, e, f, g, h) {
      if ("function" != typeof f && "function" != typeof f.handler) return c.call(this, d, e, f, g, h);
      var i;
      return f.handler ? (i = f.handler, f.handler = b.wrap(f.handler)) : (i = f, f = b.wrap(f)), f.guid = i.guid ? i.guid : i.guid = a.guid++, c.call(this, d, e, f, g, h);
    };

    var d = a.fn.ready;

    a.fn.ready = function (a) {
      return d.call(this, b.wrap(a));
    };

    var e = a.ajax;

    a.ajax = function (c, d) {
      "object" == typeof c && (d = c, c = void 0), d = d || {};

      for (var f, g = ["complete", "error", "success"]; f = g.pop();) {
        a.isFunction(d[f]) && (d[f] = b.wrap(d[f]));
      }

      try {
        return c ? e.call(this, c, d) : e.call(this, d);
      } catch (h) {
        throw b.report(h), h;
      }
    };
  }
}(window.jQuery, window.TraceKit), function (a, b, c, d) {
  function e() {
    try {
      y = null, o() && localStorage.removeItem(_), A = null, ja.createCookie(name, aa, -1);
    } catch (a) {
      ja.log("Atatus Reset User", a);
    }
  }

  function f(a, b, c, d) {
    if (a) {
      y = {}, a && (y.id = "" + a), b && (y.email = "" + b), c && (y.name = "" + c), d && (y.anonymous = d);

      try {
        o() && localStorage.setItem(_, JSON.stringify(y)), A && t(ia, {}), A = null, ja.createCookie(c, aa, -1);
      } catch (e) {
        ja.log("Atatus Set User: Invalid JSON object in LocalStorage", e);
      }
    }
  }

  function g() {
    try {
      var a;
      if (o() && (a = localStorage.getItem(_)), a) y = JSON.parse(a), A = null;else {
        var b,
            c = ja.readCookie(aa);
        c && (b = ja.readCookieElement(c, "id")), b && "undefined" !== b ? A = b : (A = ja.uuid4(), ja.createCookie(aa, A));
      }
    } catch (d) {
      ja.log("Atatus Get User: Invalid JSON object in LocalStorage", d);
    }
  }

  function h(a) {
    var b = a,
        c = a.split("//")[1];

    if (c) {
      var d = c.indexOf("?"),
          e = c.toString().substring(0, d),
          f = e.split("/").slice(0, 4).join("/"),
          g = e.substring(0, 48);
      b = f.length < g.length ? f : g, b !== e && (b += "..");
    }

    return b;
  }

  function i(a, b, c, e) {
    if (0 !== b.status && b.getAllResponseHeaders()) {
      var f = "AJAX Error: " + (b.statusText || "unknown") + " " + (c.type || "unknown") + " " + (h(c.url) || "unknown");
      na.send(e || a.type, {
        status: b.status,
        statusText: b.statusText,
        type: c.type,
        url: c.url,
        ajaxErrorMessage: f,
        contentType: c.contentType,
        requestData: c.data && c.data.slice ? c.data.slice(0, 10240) : d,
        responseData: b.responseText && b.responseText.slice ? b.responseText.slice(0, 10240) : d,
        activeTarget: a.target && a.target.activeElement && a.target.activeElement.outerHTML && a.target.activeElement.outerHTML.slice ? a.target.activeElement.outerHTML.slice(0, 10240) : d
      });
    }
  }

  function j(a) {
    if (ja.log("Atatus: Caught unhandled promise rejection:", a), a) {
      var b = a.reason;
      na.notify(b && (b instanceof Error || b.message) ? b : new Error("UnhandledRejection: " + b));
    }
  }

  function k() {
    "addEventListener" in a && a.addEventListener("unhandledrejection", j);
  }

  function l() {
    "removeEventListener" in a && a.removeEventListener("unhandledrejection", j);
  }

  function m() {
    return w && "" !== w ? !0 : (ja.log("Atatus API key has not been configured, make sure you call atatus.config(yourApiKey)"), !1);
  }

  function n() {
    var c = b.documentElement,
        d = b.getElementsByTagName("body")[0],
        e = a.innerWidth || c.clientWidth || d.clientWidth,
        f = a.innerHeight || c.clientHeight || d.clientHeight;
    return {
      width: e,
      height: f
    };
  }

  function o() {
    try {
      return "localStorage" in a && null !== a.localStorage;
    } catch (b) {
      return !1;
    }
  }

  function p(a) {
    try {
      if (o() && localStorage.length < 50) {
        var b = new Date().toJSON(),
            c = "atatusjs=" + b + "=" + ja.getRandomInt();
        "undefined" == typeof localStorage[c] && (localStorage[c] = a);
      } else ja.log("Atatus: Reached local storage limit.");
    } catch (d) {
      ja.log("Atatus: LocalStorage full, cannot save exception");
    }
  }

  function q() {
    try {
      if (o() && localStorage.length > 0) for (var a in localStorage) {
        if ("atatusjs=" === a.substring(0, 9)) {
          try {
            var b = JSON.parse(localStorage[a]);
            "apikey" in b && t(ca, b);
          } catch (c) {
            ja.log("Atatus: Invalid JSON object in LocalStorage");
          }

          localStorage.removeItem(a);
        }
      }
    } catch (c) {
      ja.log("Atatus sendSavedErrors: LocalStorage read failed!", c);
    }
  }

  function r(a, c) {
    if (c = ja.isObject(c) ? c : {}, !a.stack || !a.stack.length) return void ja.log("Atatus: Canceling send due to no stacktrace.");
    var d = c.customData && c.customData.ajaxErrorMessage || a.message;
    if (d && 0 === d.indexOf("Uncaught ") && (d = a.message.substring(9)), d = d || c.status || "Script error.", K && K.test(d)) return void ja.log("Atatus: canceling send due to Script error or ignored errors.");
    var e = [];
    a.stack && a.stack.length && ja.forEach(a.stack, function (a, b) {
      ja.endsWith(b.url, "/atatus.js") || ja.endsWith(b.url, "/atatus.min.js") || e.push({
        ln: b.line || 0,
        cn: b.column || 0,
        f: b.url || "anonymous",
        m: b.func || "[anonymous]"
      });
    });
    var f = [a.name, d, JSON.stringify(e)].join("|");
    if (f === L) return void ja.log("Atatus: canceling send due to duplicate errors");
    L = f;
    var g = c.customData;

    try {
      JSON.stringify(g);
    } catch (h) {
      var i = "Cannot add custom data; may contain circular reference";
      g = {
        error: i
      }, ja.log("Atatus: " + i);
    }

    var j = ma.getAllEvents();
    ka.clear();
    var k = {
      "class": a.name,
      url: b.location.href,
      message: d,
      name: d,
      backTraces: e,
      breadCrumbs: j,
      customData: g || null,
      tags: c.tags,
      ts: new Date().getTime()
    };

    if ("function" == typeof M && (k.groupingKey = M(k)), "function" == typeof O) {
      var l = O(k);
      l && (delete k.name, s(k));
    } else delete k.name, s(k);
  }

  function s(a) {
    t(ca, {
      customData: x || null,
      errors: [a]
    });
  }

  function t(c, d) {
    if (m()) {
      if (W && W.length && location.host && location.host.match) {
        for (var e = !1, f = W.length, g = 0; f > g; g++) {
          if (location.host.match(W[g])) {
            e = !0;
            break;
          }
        }

        if (!e) return void ja.log("Atatus: canceling send due to not a allowed domain");
      }

      if (!d.ts) {
        var h = a.screen || n();
        d.ts = new Date().getTime(), d.apikey = w, d.request = {
          url: b.location.href,
          ua: navigator.userAgent,
          w: h.width,
          h: h.height
        }, d.tags = d.tags || U, d.user = y && y.id ? y : null, d.aid = A || null, d.sid = na.sessionId || "", d.v = B || "", d._v = R || "";
      }

      if (z && (d.aip = !0), N) {
        var i = N(d);
        if (!i) return void ja.log("Atatus: canceling send due to false from beforeSend callback.");
      }

      ja.log("Sending data to Atatus Receiver:", d), c === da ? v(c, JSON.stringify(d)) : u(c, JSON.stringify(d));
    }
  }

  function u(a, b) {
    var c = ba + a + "?data=" + encodeURIComponent(b);
    if (c.length > 4e4) return void ja.log("Atatus: Canceling session send due to large payload size.");
    var d = new Image();
    d.crossOrigin = "anonymous", d.onload = function () {
      q();
    }, d.onerror = d.onabort = function () {
      Y && a === ca && p(b);
    }, d.src = c;
  }

  function v(a, c) {
    var d = b.createElement("script"),
        e = ba + a + "?data=" + encodeURIComponent(c) + "&callback=atatus._setFeatures";
    d.type = "text/javascript", d.src = e;
    var f = b.getElementsByTagName("script")[0];
    f.parentNode.insertBefore(d, f);
  }

  var w,
      x,
      y,
      z,
      A,
      B,
      C,
      D,
      E,
      F,
      G,
      H,
      I,
      J,
      K,
      L,
      M,
      N,
      O,
      P,
      Q,
      R = "3.1.1",
      S = TraceKit.noConflict(),
      T = a.atatus,
      U = [],
      V = !1,
      W = [],
      X = !1,
      Y = !1,
      Z = !1,
      $ = !1,
      _ = "atatus-user",
      aa = "atatus-aid",
      ba = "https://br-rx.atatus.com",
      ca = "/track/browser/errors",
      da = "/track/browser/perf/pageload",
      ea = "/track/browser/perf/ajax",
      fa = "/track/browser/perf/session",
      ga = "/track/browser/perf/spa",
      ha = "/track/browser/perf/txn",
      ia = "/track/browser/perf/user";
  c && (Q = c(b));
  var ja = {
    isBoolean: function isBoolean(a) {
      return "undefined" != typeof a && "boolean" == typeof a;
    },
    isString: function isString(a) {
      return "string" == typeof a;
    },
    isNumber: function isNumber(a) {
      return "number" == typeof a;
    },
    isFunction: function isFunction(a) {
      return "function" == typeof a;
    },
    isArray: function isArray(a) {
      return "[object Array]" === Object.prototype.toString.call(a);
    },
    isObject: function isObject(a) {
      return "[object Object]" === Object.prototype.toString.call(a);
    },
    serialize: function serialize(a) {
      if (!a) return "";
      if (ja.isString(a) || ja.isNumber(a) || ja.isBoolean(a) || ja.isFunction(a)) return "" + a;
      if ("object" == typeof a) try {
        return JSON.stringify(a);
      } catch (b) {
        return "Unserializable Object";
      }
      return "";
    },
    endsWith: function endsWith(a, b) {
      return a && b ? -1 !== a.indexOf(b, a.length - b.length) : !1;
    },
    joinRegExp: function joinRegExp(a) {
      for (var b, c = [], d = 0, e = a.length; e > d; d++) {
        b = a[d], ja.isString(b) ? c.push(b.replace(/([.*+?\^=!:${}()|\[\]\/\\])/g, "\\$1")) : b && b.source && c.push(b.source);
      }

      return new RegExp(c.join("|"), "i");
    },
    getTargetUrl: function getTargetUrl(b) {
      return a.XDomainRequest && X && (b = b.slice(6)), b;
    },
    now: function now() {
      return new Date().getTime();
    },
    pad: function pad(a) {
      return a = String(a), 1 === a.length && (a = "0" + a), a;
    },
    merge: function merge(a, b) {
      var c,
          d = {};

      for (c in a) {
        d[c] = a[c];
      }

      for (c in b) {
        d[c] = b[c];
      }

      return d;
    },
    mergeArray: function mergeArray(a, b) {
      return null != b ? a.concat(b) : a;
    },
    forEach: function forEach(a, b) {
      for (var c = 0; c < a.length; c++) {
        b.call(null, c, a[c]);
      }
    },
    isEmpty: function isEmpty(a) {
      for (var b in a) {
        if (a.hasOwnProperty(b)) return !1;
      }

      return !0;
    },
    getRandomInt: function getRandomInt() {
      return Math.floor(9007199254740992 * Math.random());
    },
    log: function log(b, c) {
      V && a.console && a.console.log && (a.console.log(b), c && a.console.log(c));
    },
    bind: function bind(a, b) {
      return function () {
        return a.apply(b, Array.prototype.slice.call(arguments));
      };
    },
    canAllowInsecureSubmissions: function canAllowInsecureSubmissions() {
      var b = a.navigator.userAgent,
          c = b.match(/Trident\/([\d.]+)/),
          d = c && "7.0" === c[1] ? 11 : (b = b.match(/MSIE ([\d.]+)/)) ? parseInt(b[1], 10) : !1;
      return d && 9 >= d;
    },
    uuid4: function uuid4() {
      return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function (a) {
        var b = 16 * Math.random() | 0,
            c = "x" === a ? b : 3 & b | 8;
        return c.toString(16);
      });
    },
    addEventListener: function addEventListener(b, c, d) {
      return "undefined" != typeof a.attachEvent ? a.attachEvent("on" + b, c) : a.addEventListener ? a.addEventListener(b, c, d) : void 0;
    },
    arrayFromObject: function arrayFromObject(a) {
      var b = [];

      for (var c in a) {
        a.hasOwnProperty(c) && b.push(a[c]);
      }

      return b;
    },
    createCookie: function createCookie(a, c, d) {
      try {
        var e, f;

        if (d) {
          var g = new Date();
          g.setTime(g.getTime() + 60 * d * 60 * 1e3), e = "; expires=" + g.toGMTString();
        } else e = "";

        return f = new Date().toISOString(), b.cookie = a + "=id|" + c + "&timestamp|" + f + e + "; path=/", f;
      } catch (h) {
        ja.log("Creating cookie failed.", h);
      }
    },
    readCookieElement: function readCookieElement(a, b) {
      var c = a.split(/[|&]/);
      return "id" === b ? c[1] : "timestamp" === b ? c[3] : void 0;
    },
    readCookie: function readCookie(a) {
      try {
        for (var c = a + "=", d = b.cookie.split(";"), e = 0; e < d.length; e++) {
          for (var f = d[e]; " " === f.charAt(0);) {
            f = f.substring(1, f.length);
          }

          if (0 === f.indexOf(c)) return f.substring(c.length, f.length);
        }

        return null;
      } catch (g) {
        ja.log("Reading cookie failed.", g);
      }
    }
  },
      ka = {
    eventObject: {},
    all: function all(a) {
      for (var b = this.getEventObject(a), c = [], d = 0; d < b.length; d++) {
        c.push(b[d].value);
      }

      return c;
    },
    clear: function clear() {
      for (var a in this.eventObject) {
        this.eventObject.hasOwnProperty(a) && (this.eventObject[a].length = 0);
      }
    },
    add: function add(a, b) {
      var c = this.getEventObject(a),
          d = ja.uuid4();
      return c.push({
        key: d,
        value: b
      }), this.truncateEventObject(a, 10), d;
    },
    get: function get(a, b) {
      for (var c = this.getEventObject(a), d = 0; d < c.length; d++) {
        if (c[d].key === b) return c[d].value;
      }

      return !1;
    },
    getEventObject: function getEventObject(a) {
      return this.eventObject[a] || (this.eventObject[a] = []), this.eventObject[a];
    },
    truncateEventObject: function truncateEventObject(a, b) {
      var c = this.getEventObject(a);
      c.length > b && (this.eventObject[a] = c.slice(c.length - b));
    }
  },
      la = {
    attach: function attach(b, c, d, e, f) {
      b = b || a.console || {};

      for (var g = f || ["log", "debug", "info", "warn", "error"], h = g.pop(), i = function i(a, b, d) {
        c && ka.add("timeline", {
          ts: ja.now(),
          c: "console",
          l: a,
          m: ja.serialize(b)
        }), "error" === a && e && na.notify(new Error(b), d);
      }; h;) {
        this.wrapConsoleMethod(b, h, d, i), h = g.pop();
      }
    },
    wrapConsoleMethod: function wrapConsoleMethod(a, b, c, d) {
      var e = a[b],
          f = a;
      b in a && (a[b] = function () {
        var a = [].slice.call(arguments),
            g = "" + a.join(" "),
            h = {
          level: b,
          logger: "console"
        };
        d && d(b, g, h), e && c && Function.prototype.apply.call(e, f, a);
      });
    }
  },
      ma = {
    attach: function attach() {
      var a = ja.bind(this.onDocumentClicked, this),
          c = ja.bind(this.onInputChanged, this);
      b.addEventListener ? (b.addEventListener("click", a, !0), b.addEventListener("blur", c, !0)) : b.attachEvent && (b.attachEvent("onclick", a), b.attachEvent("onfocusout", c));
    },
    writeUserEvent: function writeUserEvent(a, b, c, d) {
      "password" === this.getElementType(a) && (c = void 0), ka.add("timeline", {
        ts: ja.now(),
        a: b,
        e: this.getOuterHTML(a),
        v: this.getValueKind(c, d)
      });
    },
    onDocumentClicked: function onDocumentClicked(a) {
      var b = this.getElementFromEvent(a);
      b && b.tagName && (this.isTarget(b, "a") || this.isTarget(b, "button") || this.isTarget(b, "input", ["button", "submit"]) ? this.writeUserEvent(b, "click") : this.isTarget(b, "input", ["checkbox", "radio"]) && this.writeUserEvent(b, "check", b.value, b.checked));
    },
    onInputChanged: function onInputChanged(a) {
      var b = this.getElementFromEvent(a);
      b && b.tagName && (this.isTarget(b, "textarea") ? this.writeUserEvent(b, "input", b.value) : this.isTarget(b, "select") && b.options && b.options.length ? this.onSelectInputChanged(b) : this.isTarget(b, "input") && !this.isTarget(b, "input", ["button", "submit", "hidden", "checkbox", "radio"]) && this.writeUserEvent(b, "input", b.value));
    },
    onSelectInputChanged: function onSelectInputChanged(a) {
      if (a.multiple) {
        for (var b = 0; b < a.options.length; b++) {
          if (a.options[b].selected) {
            this.writeUserEvent(a, "select", a.options[b].value);
            break;
          }
        }
      } else 0 <= a.selectedIndex && a.options[a.selectedIndex] && this.writeUserEvent(a, "select", a.options[a.selectedIndex].value);
    },
    getElementFromEvent: function getElementFromEvent(a) {
      return a.target || b.elementFromPoint(a.clientX, a.clientY);
    },
    isTarget: function isTarget(a, b, c) {
      if (a.tagName.toLowerCase() !== b.toLowerCase()) return !1;
      if (!c) return !0;

      for (var d = this.getElementType(a), e = 0; e < c.length; e++) {
        if (c[e] === d) return !0;
      }

      return !1;
    },
    getElementType: function getElementType(a) {
      return (a.getAttribute("type") || "").toLowerCase();
    },
    getOuterHTML: function getOuterHTML(a) {
      for (var b = "<" + a.tagName.toLowerCase(), c = a.attributes, d = 0, e = c.length; e > d; d++) {
        var f = c[d].name;
        "value" !== f.toLowerCase() && (b += " " + f + '="' + c[d].value + '"');
      }

      return b += " >";
    },
    getValueKind: function getValueKind(a, b) {
      return null == a ? null : {
        length: a.length,
        checked: b,
        pattern: this.matchInputPattern(a)
      };
    },
    matchInputPattern: function matchInputPattern(a) {
      return "" === a ? "empty" : /^[a-z0-9!#$%&'*+=?\^_`{|}~\-]+(?:\.[a-z0-9!#$%&'*+=?\^_`{|}~\-]+)*@(?:[a-z0-9](?:[a-z0-9\-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9\-]*[a-z0-9])?$/.test(a) ? "email" : /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/.test(a) || /^(\d{4}[\/\-](0?[1-9]|1[012])[\/\-]0?[1-9]|[12][0-9]|3[01])$/.test(a) ? "date" : /^(?:(?:\+?1\s*(?:[.\-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.\-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.\-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/.test(a) ? "phone" : /^\s*$/.test(a) ? "whitespace" : /^\d*$/.test(a) ? "numeric" : "character";
    },
    getAllEvents: function getAllEvents() {
      return ka.all("timeline");
    }
  },
      na = {
    VERSION: R,
    noConflict: function noConflict() {
      return a.atatus = T, na;
    },
    isConfigured: function isConfigured() {
      return !!w;
    },
    config: function config(b, c) {
      if (c = c || {}, w = b, S.remoteFetching = !1, K = [], c && (x = c.customData, U = c.tags || [], V = !!c.debugMode, z = !!c.anonymizeIp, Z = !!c.reportAjaxErrors, $ = !!c.reportUnhandledRejections, C = !!c.disableBreadcrumbs, D = !!c.disableErrorTracking, H = !!c.disableRUM, E = !!c.disableAjaxMonitoring, F = c.disableSession === d ? !1 : c.disableSession, G = c.disableSPA === d ? !0 : c.disableSPA, c.ignoreErrors && ja.isArray(c.ignoreErrors) && (K = c.ignoreErrors), na.setAllowedDomains(c.allowedDomains), na.setVersion(c.version), na.enableOffline(c.enableOffline || c.offline), na.onBeforeSend(c.beforeSend), na.onBeforeErrorSend(c.beforeErrorSend), na.setGroupingKeyCallback(c.groupingKeyCallback)), X = ja.canAllowInsecureSubmissions(), K.push(/^Script error\.?$/), K.push(/^Javascript error: Script error\.? on line 0$/), K = ja.joinRegExp(K), q(), J = {
        enabled: !1,
        timeline: !0,
        display: !0,
        error: !0,
        levels: null
      }, ja.isBoolean(c.console) && (J.enabled = c.console), ja.isBoolean(c.consoleTimeline) && (J.timeline = c.consoleTimeline), ja.isBoolean(c.consoleDisplay) && (J.display = c.consoleDisplay), ja.isBoolean(c.consoleErrorNotify) && (J.error = c.consoleErrorNotify), ja.isArray(c.consoleTimelineLevels) && (J.levels = c.consoleTimelineLevels), J.enabled && "console" in a && a.console.log && la.attach(a.console, J.timeline, J.display, J.error, J.levels), C || ma.attach(), E || H || na.__attachAjaxHooks(), !H && na.SessionTracking) {
        var e = function e() {
          P = new na.SessionTracking(), P.attach(F);
        };

        a.addEventListener ? a.addEventListener("load", e) : a.attachEvent("onload", e);
      }

      return g(), na;
    },
    install: function install() {
      return m() ? (D || (S.report.subscribe(r), S.extendToAsynchronousCallbacks(), Q && Z && Q.ajaxError(i), $ && k()), na) : na;
    },
    uninstall: function uninstall() {
      return w = null, D || (S.report.unsubscribe(r), Q && Z && Q.unbind("ajaxError", i), $ && l()), na;
    },
    setCustomData: function setCustomData(a) {
      return x = a, na;
    },
    setTags: function setTags(a) {
      return a && ja.isArray(a) && (U = a), na;
    },
    setAllowedDomains: function setAllowedDomains(a) {
      return a && ja.isArray(a) && (W = a), na;
    },
    getAllowedDomains: function getAllowedDomains() {
      return W;
    },
    setUser: function setUser(a, b, c, d) {
      return f(a, b, c, d), na;
    },
    resetUser: function resetUser() {
      return e(), na;
    },
    setVersion: function setVersion(a) {
      return a && (B = "" + a), na;
    },
    enableOffline: function enableOffline(a) {
      return ja.isBoolean(a) && (Y = a), na;
    },
    onBeforeSend: function onBeforeSend(a) {
      return ja.isFunction(a) && (N = a), na;
    },
    onBeforeErrorSend: function onBeforeErrorSend(a) {
      return ja.isFunction(a) && (O = a), na;
    },
    setGroupingKeyCallback: function setGroupingKeyCallback(a) {
      return ja.isFunction(a) && (M = a), na;
    },
    setAPIEndpoint: function setAPIEndpoint(a) {
      return ba = a, na;
    },
    getAPIEndpoint: function getAPIEndpoint() {
      return ba;
    },
    init: function init(a, b, c) {
      return c && (b = b || {}, b.customData = c), na.config(a, b);
    },
    withCustomData: function withCustomData(a) {
      return na.setCustomData(a);
    },
    withTags: function withTags(a) {
      return na.setTags(a);
    },
    attach: function attach() {
      return na.install();
    },
    detach: function detach() {
      return na.uninstall();
    },
    endSession: function endSession() {
      return P && P.endSession(), na;
    },
    _setFeatures: function _setFeatures(a) {
      ja.isObject(a) && (E = !!a.daj, F = !!a.dss, G = !!a.dspa, H = !!a.drum, I = !!a.d, a.error && ja.log("Error in sending data to Atatus", a.error));
    },
    measureRoute: function measureRoute(a) {
      return P && a && P.virtualPageLoaded(a), na;
    },
    leaveBreadcrumb: function leaveBreadcrumb(a, b) {
      return a ? (ka.add("timeline", {
        ts: ja.now(),
        c: "breadcrumb",
        l: b || "info",
        m: ja.serialize(a)
      }), na) : void 0;
    },
    notify: function notify(a, b, c) {
      return "string" == typeof a ? void ja.log("atatus.notify() was called with a string. Expected instance of Error.") : na.send(a, b, c);
    },
    sendPerf: function sendPerf(a) {
      return H ? void ja.log("RUM is disabled. Please enable it in the config options.") : t(da, a);
    },
    sendAjaxPerf: function sendAjaxPerf(a) {
      return H || E ? void ja.log("AJAX monitoring is disabled. Please enable it in the config options.") : t(ea, a);
    },
    sendSessionPerf: function sendSessionPerf(a) {
      return H || F ? void ja.log("Session Tracking is disabled. Please enable it in the config options.") : t(fa, a);
    },
    sendSPAPerf: function sendSPAPerf(a) {
      return H || G ? void ja.log("SPA Tracking is disabled. Please enable it in the config options.") : t(ga, a);
    },
    sendTxnPerf: function sendTxnPerf(a) {
      return t(ha, a);
    },
    send: function send(a, b, c) {
      try {
        r(S.computeStackTrace(a), {
          customData: b,
          tags: c
        });
      } catch (d) {
        if (a !== d) throw d;
      }

      return na;
    },
    _helper: ja
  };
  a.atatus = na, "object" == typeof exports && "undefined" != typeof module ? (module.exports = na, "undefined" != typeof global && (global.atatus = na)) : "function" == typeof define && define.amd && ("object" == typeof require && require.load ? define(function () {
    return na;
  }) : define("atatus", function () {
    return na;
  }));
}(window, document, window.jQuery), function (a, b, c, d) {
  function e(a) {
    a.pl <= 0 || c.sendPerf(a);
  }

  function f() {
    var b = a.performance || a.mozPerformance || a.msPerformance || a.webkitPerformance,
        c = b.timing;
    if (0 === c.loadEventEnd) return !1;
    clearInterval(j), j = null;
    var d = c.navigationStart;
    0 >= d && (d = c.fetchStart);
    var f = {};

    for (var g in k) {
      f[k[g]] = -1, g in c && (c[g] <= 0 || (f[k[g]] = c[g] - d));
    }

    var h = {
      nt: f.rps - f.ns,
      dp: f.dce - f.rps,
      pr: f.le - f.dce
    };
    e(h);
  }

  function g() {
    if (!i || !i.bDone) return !1;
    clearInterval(j), j = !1;
    var a = i.getMeasures();

    if (null != a && null != a.backend && null != a.frontend && null != a["page load time"] && null != a["total load time"]) {
      var b = a.backend,
          c = a.backend + a.frontend,
          d = {
        nt: b,
        dp: c - b,
        pr: a["total load time"] - c,
        fe: a["total load time"] - b,
        pl: a["total load time"]
      };
      e(d);
    }
  }

  var h = new Date().getTime(),
      i = i || {};
  i.q = i.q || [], i.version = "0.3", i.targetOrigin = b.location.protocol + "//" + b.location.hostname, i.bPostMessage = !1, i.beaconUrl = i.beaconUrl || "/images/beacon.gif", i.autorun = !1, i.init = function () {
    if (i.bDone = !1, i.bUnloaded = !1, i.marks = {}, i.measures = {}, i.starts = {}, i.findStartTime(), i.addEventListener("beforeunload", i.beforeUnload, !1), i.addEventListener("pagehide", i.beforeUnload, !1), i.addEventListener("unload", i.beforeUnload, !1), i.processQ(), "complete" === b.readyState) {
      var c = a.performance || a.mozPerformance || a.msPerformance || a.webkitPerformance;
      c && "undefined" != typeof c.timing && "undefined" != typeof c.timing.loadEventEnd && (i.mark("firstbyte", c.timing.responseStart), i.mark("onload", c.timing.loadEventEnd)), i.done();
    } else i.addEventListener("load", i.onload, !1);
  }, i.processQ = function () {
    for (var a = i.q.length, b = 0; a > b; b++) {
      var c = i.q[b],
          d = c[0];
      "mark" === d ? i.mark(c[1], c[2]) : "measure" === d ? i.measure(c[1], c[2], c[3]) : "done" === d && i.done(c[1]);
    }
  }, i.mark = function (b, c) {
    return i.dprint("RUM_EPISODES.mark: " + b + ", " + c), b ? (i.marks[b] = parseInt(c || new Date().getTime()), i.bPostMessage && a.postMessage("RUM_EPISODES:mark:" + b + ":" + c, i.targetOrigin), void ("firstbyte" === b ? i.measure("backend", "starttime", "firstbyte") : "onload" === b ? (i.measure("frontend", "firstbyte", "onload"), i.measure("page load time", "starttime", "onload")) : "done" === b && i.measure("total load time", "starttime", "done"))) : void i.dprint("Error: markName is undefined in RUM_EPISODES.mark.");
  }, i.measure = function (b, c, d) {
    if (i.dprint("RUM_EPISODES.measure: " + b + ", " + c + ", " + d), !b) return void i.dprint("Error: episodeName is undefined in RUM_EPISODES.measure.");
    var e;
    if ("undefined" == typeof c) e = "number" == typeof i.marks[b] ? i.marks[b] : new Date().getTime();else if ("number" == typeof i.marks[c]) e = i.marks[c];else {
      if ("number" != typeof c) return void i.dprint("Error: unexpected startNameOrTime in RUM_EPISODES.measure: " + c);
      e = c;
    }
    var f;
    if ("undefined" == typeof d) f = new Date().getTime();else if ("number" == typeof i.marks[d]) f = i.marks[d];else {
      if ("number" != typeof d) return void i.dprint("Error: unexpected endNameOrTime in RUM_EPISODES.measure: " + d);
      f = d;
    }
    i.starts[b] = parseInt(e), i.measures[b] = parseInt(f - e), i.bPostMessage && a.postMessage("RUM_EPISODES:measure:" + b + ":" + e + ":" + f, i.targetOrigin);
  }, i.done = function (b) {
    i.bDone = !0, i.mark("done"), i.bPostMessage && a.postMessage("RUM_EPISODES:done", i.targetOrigin), "function" == typeof b && b();
  }, i.getMarks = function () {
    return i.marks;
  }, i.getMeasures = function () {
    return i.measures;
  }, i.getStarts = function () {
    return i.starts;
  }, i.findStartTime = function () {
    var a = i.findStartWebTiming() || i.findStartCookie();
    a && i.mark("starttime", a);
  }, i.findStartWebTiming = function () {
    var b,
        c = a.performance || a.mozPerformance || a.msPerformance || a.webkitPerformance;
    return c && "undefined" != typeof c.timing && "undefined" != typeof c.timing.navigationStart && (b = c.timing.navigationStart, i.dprint("RUM_EPISODES.findStartWebTiming: startTime = " + b)), b;
  }, i.findStartCookie = function () {
    try {
      for (var c = b.cookie.split(" "), e = 0; e < c.length; e++) {
        if (0 === c[e].indexOf("RUM_EPISODES=")) {
          for (var f, g, h = c[e].substring("RUM_EPISODES=".length).split("&"), j = 0; j < h.length; j++) {
            if (0 === h[j].indexOf("s=")) f = h[j].substring(2);else if (0 === h[j].indexOf("r=")) {
              var k = h[j].substring(2);
              k = k.replace(/;$/, ""), g = a.escape(b.referrer) === k;
            }
          }

          if (g && f) return i.dprint("RUM_EPISODES.findStartCookie: startTime = " + f), f;
        }
      }
    } catch (l) {}

    return d;
  }, i.beforeUnload = function () {
    try {
      if (i.bUnloaded) return;
      b.cookie = "RUM_EPISODES=s=" + Number(new Date()) + "&r=" + a.escape(b.location) + "; path=/", i.bUnloaded = !0;
    } catch (c) {}
  }, i.onload = function () {
    i.mark("onload"), i.done();
  }, i.addEventListener = function (b, c, d) {
    return "undefined" != typeof a.attachEvent ? a.attachEvent("on" + b, c) : a.addEventListener ? a.addEventListener(b, c, d) : void 0;
  }, i.dprint = function () {}, i.init();
  var j = null,
      k = {
    navigationStart: "ns",
    redirectStart: "rds",
    redirectEnd: "rde",
    unloadEventStart: "us",
    unloadEventEnd: "ue",
    fetchStart: "fs",
    domainLookupStart: "dls",
    domainLookupEnd: "dle",
    connectStart: "cs",
    secureConnectionStart: "scs",
    connectEnd: "ce",
    handshakeStart: "hs",
    requestStart: "rqs",
    responseStart: "rps",
    responseEnd: "rpe",
    domLoading: "dl",
    domInteractive: "di",
    domContentLoadedEventStart: "dcs",
    domContentLoadedEventEnd: "dce",
    domComplete: "dc",
    loadEventStart: "ls",
    loadEventEnd: "le"
  },
      l = a.performance || a.mozPerformance || a.msPerformance || a.webkitPerformance;
  l && "undefined" != typeof l.timing && "undefined" != typeof l.navigation ? j = setInterval(f, 100) : (i.mark("firstbyte", h), j = setInterval(g, 100));
}(window, document, window.atatus), function (a, b, c) {
  b.SessionTracking = function () {
    function d(a) {
      var c = p.readCookie(q.cookieName),
          d = null === c,
          e = "string" == typeof exisitingCookie && c.length > 0 && -1 === c.indexOf("timestamp"),
          f = null,
          g = null;

      if (!d && !e) {
        g = new Date(p.readCookieElement(c, "timestamp"));
        var h = new Date(new Date() - s);
        f = h > g;
      }

      if (d || e || f) b.sessionId = p.uuid4(), q.existingTimestamp = p.createCookie(q.cookieName, b.sessionId), a(!0);else {
        var i = p.readCookieElement(c, "id");
        "undefined" === i ? (b.sessionId = p.uuid4(), q.existingTimestamp = p.createCookie(q.cookieName, b.sessionId), a(!0)) : (b.sessionId = i, q.existingTimestamp = g, a(!1));
      }
    }

    function e() {
      var a;

      if (q.existingTimestamp) {
        var b = new Date(new Date() - s);
        a = q.existingTimestamp < b;
      }

      a && (q.stopSession = !0);
    }

    function f(a) {
      return Math.min(a, 3e5);
    }

    function g(a) {
      for (var b in a) {
        isNaN(a[b]) && "string" != typeof a[b] && (a[b] = 0);
      }

      return a;
    }

    function h(b, c) {
      var d;
      return d = "object" == typeof a.performance && "function" == typeof a.performance.now ? a.performance.now() : 0, {
        du: Math.min(q.maxVirtualPageDuration, d - (b || c)),
        o: Math.min(q.maxVirtualPageDuration, d - c)
      };
    }

    function i(a) {
      var b = {
        du: a.loadEventEnd - a.navigationStart,
        s: a.fetchStart
      };
      return a.domainLookupStart && a.domainLookupStart > 0 && (b.dls = a.domainLookupStart - a.fetchStart), a.domainLookupEnd && a.domainLookupEnd > 0 && (b.dle = a.domainLookupEnd - a.fetchStart), a.connectStart && a.connectStart > 0 && (b.cs = a.connectStart - a.fetchStart), a.connectEnd && a.connectEnd > 0 && (b.ce = a.connectEnd - a.fetchStart), a.responseStart && a.responseStart > 0 && (b.rps = a.responseStart - a.fetchStart), a.responseEnd && a.responseEnd > 0 && (b.rpe = a.responseEnd - a.fetchStart), a.domLoading && a.domLoading > 0 && (b.dl = a.domLoading - a.fetchStart), a.domInteractive && a.domInteractive > 0 && (b.di = a.domInteractive - a.fetchStart), a.domContentLoadedEventEnd && a.domContentLoadedEventEnd > 0 && (b.dce = a.domContentLoadedEventEnd - a.fetchStart), a.domComplete && a.domComplete > 0 && (b.dc = f(a.domComplete - a.fetchStart)), a.loadEventStart && a.loadEventStart > 0 && (b.ls = a.loadEventStart - a.fetchStart), a.loadEventEnd && a.loadEventEnd > 0 && (b.le = a.loadEventEnd - a.fetchStart), a.secureConnectionStart && a.secureConnectionStart > 0 && (b.scs = a.secureConnectionStart - a.connectStart - a.fetchStart), b = g(b);
    }

    function j(a, b) {
      var c = {
        du: f(a.duration),
        s: b + a.fetchStart
      };
      return a.domainLookupStart && a.domainLookupStart > 0 && (c.dls = a.domainLookupStart - a.fetchStart), a.domainLookupEnd && a.domainLookupEnd > 0 && (c.dle = a.domainLookupEnd - a.fetchStart), a.connectStart && a.connectStart > 0 && (c.cs = a.connectStart - a.fetchStart), a.connectEnd && a.connectEnd > 0 && (c.ce = a.connectEnd - a.fetchStart), a.responseStart && a.responseStart > 0 && (c.rps = a.responseStart - a.fetchStart), a.responseEnd && a.responseEnd > 0 && (c.rpe = a.responseEnd - a.fetchStart), a.secureConnectionStart && a.secureConnectionStart > 0 && (c.scs = a.secureConnectionStart - a.connectStart - a.fetchStart), c = g(c);
    }

    function k() {
      var b = a.location.pathname,
          c = a.location.protocol + "//" + a.location.host + b;
      return c.length > 800 && (c = c.substring(0, 800)), {
        u: c,
        t: i(a.performance.timing),
        g: "p"
      };
    }

    function l(b, c, d) {
      var e = a.location.protocol + "//" + a.location.host + b;
      return e.length > 800 && (e = e.substring(0, 800)), {
        u: e,
        t: h(c, d),
        g: "r"
      };
    }

    function m(b, c) {
      var d = b.name.split("?")[0];
      return d.length > 800 && (d = d.substring(0, 800)), {
        u: d,
        t: j(b, c ? 0 : a.performance.timing.navigationStart),
        g: "xmlhttprequest" === b.initiatorType || "fetch" === b.initiatorType ? "x" : "s",
        z: b.decodedBodySize || 0
      };
    }

    function n(b, d) {
      if (a.performance !== c && a.performance.getEntriesByType) try {
        for (var e = a.performance.getEntriesByType("resource"), f = q.offset; f < e.length; f++) {
          var g = e[f].name.split("?")[0];
          0 !== g.indexOf(q.atatusHost) && (g.indexOf("favicon.ico") > 0 || 0 !== g.indexOf("about:blank") && ("j" !== g[0] || 1 !== g.indexOf("avascript:")) && 0 !== g.indexOf("chrome-extension://") && 0 !== g.indexOf("res://") && 0 !== g.indexOf("file://") && b.push(m(e[f], d)));
        }

        q.offset = e.length;
      } catch (h) {}
    }

    function o(b, d, e, f) {
      if (a.performance === c || a.performance.timing === c || a.performance.timing.fetchStart === c || isNaN(a.performance.timing.fetchStart)) return null;
      var g = [{
        rs: []
      }];

      if (d && (e && (f ? g[0].p = k() : g[0].rs.push(k())), n(g[0].rs)), b) {
        q.pendingVirtualPage && (g[0].r = q.pendingVirtualPage);
        var h = null == q.pendingVirtualPage;
        if (q.pendingVirtualPage = l(b, q.previousVirtualPageLoadTimestamp, q.initalStaticPageLoadTimestamp), !h && g.length > 0) return g;
      }

      return g;
    }

    var p = b._helper,
        q = this,
        r = {};
    b.sessionId = null, this.cookieName = "atatus-sid", this.virtualPage = null, this.heartBeatInterval = null, this.offset = 0, this.atatusHost = b.getAPIEndpoint(), this.maxVirtualPageDuration = 18e5;
    var s = 6e5;
    this.existingTimestamp = null, this.stopSession = !1, this.sendSessionPayload = function (a) {
      q.stopSession || b.sendSessionPerf(a);
    }, this.sendSPAPayload = function (a) {
      b.sendSPAPerf(a);
    }, this.attach = function (b) {
      if (!b) {
        d(function (a) {
          setTimeout(function () {
            q.pageLoaded(a);
          }, 5e3);
        });

        var c = function c() {
          var a = [{
            rs: []
          }];

          if (n(a[0].rs), a[0].rs.length > 0) {
            var b = {
              data: a
            };
            q.sendSessionPayload(b);
          }
        },
            e = function () {
          this.watchCookieTimestamp();
        }.bind(r),
            f = function () {
          "visible" === document.visibilityState && this.watchCookieTimestamp();
        }.bind(r);

        a.addEventListener ? (a.addEventListener("click", e), document.addEventListener("visibilitychange", f), a.addEventListener("beforeunload", c)) : a.attachEvent && document.attachEvent("onclick", e);
      }
    }, this.pageLoaded = function (b) {
      q.sendPerformance(!0, !0, b), q.heartBeat(), q.initalStaticPageLoadTimestamp = "object" == typeof a.performance && "function" == typeof a.performance.now ? a.performance.now() : 0;
    }, this.endSession = function () {
      q.stopSession = !0, p.createCookie(q.cookieName, b.sessionId, -1);
    }, this.heartBeat = function () {
      q.heartBeatInterval = setInterval(function () {
        var a = [{
          rs: []
        }];

        if (n(a[0].rs, q.virtualPage), a[0].rs.length > 0) {
          var b = {
            data: a
          };
          q.sendSessionPayload(b);
        }
      }, 3e4);
    }, this.virtualPageLoaded = function (b) {
      var c = null == this.virtualPage;
      "string" == typeof b && (b.length > 0 && "/" !== b[0] && (b += "/"), b.length > 800 && (b = b.substring(0, 800)), this.virtualPage = b), c ? this.sendPerformance(!0, !1, !1) : this.sendPerformance(!1, !1, !1), "string" == typeof b && (this.previousVirtualPageLoadTimestamp = "object" == typeof a.performance && "function" == typeof a.performance.now ? a.performance.now() : 0);
    }, this.sendPerformance = function (a, b, c) {
      var d = o(this.virtualPage, a, b, c);

      if (d) {
        var e = {
          data: d
        };
        d[0].r ? q.sendSPAPayload(e) : d[0].rs.length > 0 && q.sendSessionPayload(e);
      }
    }, r.watchCookieTimestamp = e;
  };
}(window, window.atatus), function (a, b, c) {
  c.__attachAjaxHooks = function () {
    var d = c._helper,
        e = {
      queue: [],
      batchSize: 25,
      processing: !1,
      bUnloaded: !1,
      push: function push(a) {
        "string" == typeof a.url && a.url.indexOf(".html") > 0 || (this.queue.push(a), this.queue.length >= this.batchSize && this._processQueue());
      },
      _processQueue: function _processQueue() {
        if (!this.processing && this.queue.length) {
          this.processing = !0;

          try {
            for (var a = {}, b = {}, e = 0; e < this.queue.length; e++) {
              var f,
                  g = this.queue[e],
                  h = g.status;

              if (400 > h) {
                f = g.method + g.url;
                var i = g.respAvailTime - g.sendTime,
                    j = g.respProcTime - g.respAvailTime,
                    k = g.receivedSize,
                    l = g.sendSize,
                    m = a[f];
                m ? (m.rt.push(i), m.ct.push(j), m.rz.push(k), m.sz.push(l)) : a[f] = {
                  m: g.method,
                  u: g.url,
                  rt: [i],
                  ct: [j],
                  rz: [k],
                  sz: [l]
                };
              } else {
                f = g.method + h + g.url;
                var n = b[f];
                n && n.sc ? n.sc[h] ? n.sc[h]++ : n.sc[h] = 1 : (b[f] = {
                  m: g.method,
                  u: g.url,
                  sc: {}
                }, b[f].sc[h] = 1);
              }
            }

            var o = {
              xhr: d.arrayFromObject(a),
              xhrError: d.arrayFromObject(b)
            };
            c.sendAjaxPerf(o);
          } catch (p) {
            d.log("Error while processing queue: ", p);
          } finally {
            this.queue = [], this.processing = !1;
          }
        }
      },
      beforeUnload: function beforeUnload() {
        e.bUnloaded || (e._processQueue(), e.bUnloaded = !0);
      }
    };
    d.addEventListener("beforeunload", e.beforeUnload, !1);
    var f = {
      support: function support(a) {
        return !a || "apply" in a;
      },
      around: function around(a, b, c, e) {
        return a = a || function () {}, function () {
          var f,
              g = Array.prototype.slice.call(arguments);

          try {
            b && (f = b.apply(this, g));
          } catch (h) {
            d.log(e, h);
          }

          var i;

          try {
            i = a.apply(this, f || g);
          } finally {
            try {
              c && c.apply(this, g);
            } catch (h) {
              d.log(e, h);
            }
          }

          return i;
        };
      },
      before: function before(a, b) {
        return f.around(a, b);
      },
      after: function after(a, b) {
        return f.around(a, null, b);
      },
      timeout: function timeout(a) {
        setTimeout(a, 0);
      },
      wrapAddEventListener: function wrapAddEventListener() {
        return function (a, b) {
          if (("load" === a || "error" === a) && b && this._atrumXhrData) {
            var c;
            b.__atrumInterceptor ? c = b.__atrumInterceptor : f.support(b) ? (c = h.wrapXHR(b, this, "XHR.invokeEventListener"), b.__atrumInterceptor = c) : c = null;
            var d;
            return c && (d = Array.prototype.slice.call(arguments), d[1] = c), d;
          }
        };
      },
      wrapRemoveEventListener: function wrapRemoveEventListener() {
        return function (a, b) {
          if (this._atrumXhrData) {
            var c = Array.prototype.slice.call(arguments);
            return b.__atrumInterceptor && (c[1] = b.__atrumInterceptor), c;
          }
        };
      },
      aroundWithHandleEvent: function aroundWithHandleEvent(a, b, c, d) {
        var e = a;
        return a && "object" == typeof a && "toString" in a && "[xpconnect wrapped nsIDOMEventListener]" === a.toString() && "handleEvent" in a && (e = function e() {
          a.handleEvent.apply(this, Array.prototype.slice.call(arguments));
        }), f.around(e, b, c, d);
      },
      getFullyQualifiedUrl: function getFullyQualifiedUrl(a) {
        var c = b.createElement("a");
        return c.href = a, c.href;
      }
    };

    if (a.XMLHttpRequest && a.XMLHttpRequest.prototype) {
      var g = a.XMLHttpRequest.prototype;
      if (!("open" in g && "send" in g)) return;
      if (!f.support(g.open) || !f.support(g.send)) return;
      var h = {};
      h.captureAjaxTimings = function (a) {
        var b = a._atrumXhrData;

        if (b) {
          var c = new Date().getTime();
          2 === a.readyState ? b.firstByteTime = b.firstByteTime || c : 4 === a.readyState && (b.respAvailTime = b.respAvailTime || c, b.firstByteTime = b.firstByteTime || c);
        }
      }, h.sendPayload = function (a, b) {
        b.receivedSize = 0, a.responseType && "text" !== a.responseType || "string" == typeof a.responseText && (b.receivedSize = a.responseText.length), b.status = a.status, e.push(b);
      }, h.wrapXHR = function (a, b, c) {
        return f.aroundWithHandleEvent(a, function () {
          h.captureAjaxTimings(this);
        }, function () {
          var a = b._atrumXhrData;

          if (a && 4 === b.readyState) {
            var c = new Date().getTime();
            a.respProcTime = a.respProcTime || c, h.sendPayload(b, a), delete b._atrumXhrData;
          }
        }, c);
      }, h.ajaxDone = function (a) {
        if (a._atrumXhrData) {
          var b = new Date().getTime() + 3e4,
              c = function c() {
            h.captureAjaxTimings(a);
            var d = a._atrumXhrData;

            if (d) {
              var e = new Date().getTime();
              4 === a.readyState ? (d.respProcTime = d.respProcTime || e, h.sendPayload(a, d), delete a._atrumXhrData) : b > e ? setTimeout(c, 50) : delete a._atrumXhrData;
            }
          };

          c();
        }
      }, g.open = f.around(g.open, function () {
        var a = 1 <= arguments.length ? String(arguments[0]) : "",
            b = 2 <= arguments.length ? String(arguments[1]) : "",
            d = c.getAllowedDomains(),
            e = !0;

        if (b = f.getFullyQualifiedUrl(b), b && d && d.length) {
          e = !1;

          for (var g = 0; g < d.length; g++) {
            var h = d[g];

            if (h && b.match && b.match(h)) {
              e = !0;
              break;
            }
          }
        }

        e && (b = b && b.split("?")[0], this._atrumXhrData = {
          method: a,
          url: b,
          sendTime: null,
          sendSize: null,
          firstByteTime: null,
          respAvailTime: null,
          respProcTime: null,
          receivedSize: null,
          parentPhase: null
        });
      }, null, "XHR.open"), g.send = f.around(g.send, function () {
        var a = this,
            b = a._atrumXhrData;

        if (b) {
          var c = new Date().getTime();
          b.sendTime = b.sendTime || c, b.sendSize = 1 <= arguments.length && arguments[0] ? arguments[0].length || 0 : 0;

          var d = 0,
              e = function e() {
            if (4 === a.readyState) h.ajaxDone(a);else {
              var b = null;

              try {
                b = a.onreadystatechange;
              } catch (c) {
                return void h.ajaxDone(a);
              }

              d++, b ? f.support(b) ? a.onreadystatechange = h.wrapXHR(b, a, "XHR.onReadyStateChange") : h.ajaxDone(a) : 5 > d ? f.timeout(e) : h.ajaxDone(a);
            }
          };

          e();
        }
      }, null, "XHR.send"), "addEventListener" in g && "removeEventListener" in g && f.support(g.addEventListener) && f.support(g.removeEventListener) && (g.addEventListener = f.around(g.addEventListener, f.wrapAddEventListener(), null, "XHR.addEventListener"), g.removeEventListener = f.around(g.removeEventListener, f.wrapRemoveEventListener(), null, "XHR.removeEventListener"));
    }

    if ("fetch" in a && !a.fetch.polyfill) {
      var i = a.fetch;

      a.fetch = function (a) {
        return function () {
          for (var b = new Array(arguments.length), c = 0; c < b.length; ++c) {
            b[c] = arguments[c];
          }

          var d = "GET",
              f = 0;
          b[1] && (b[1].method && (d = b[1].method), "string" == typeof b[1].body && (f = b[1].body.length));
          var g = {
            url: b[0],
            method: d,
            sendSize: f,
            receivedSize: 0,
            sendTime: new Date().getTime(),
            respAvailTime: 0,
            respProcTime: 0
          };
          return a.apply(this, b).then(function (a) {
            return g.respAvailTime = new Date().getTime(), g.respProcTime = g.respAvailTime, g.status = a.status, a.headers && a.headers.get && (g.receivedSize = a.headers.get("Content-Length")), e.push(g), a;
          });
        };
      }(i);
    }
  };
}(window, document, window.atatus), function (a, b) {
  function c(a, c, d) {
    if (!(0 >= c)) {
      var e = {
        data: [{
          t: {
            n: a,
            s: d,
            t: {
              du: c
            }
          }
        }]
      };
      b.sendTxnPerf(e);
    }
  }

  function d(a) {
    return i + " " + a;
  }

  function e() {
    try {
      return "localStorage" in a && null !== a.localStorage;
    } catch (b) {
      return !1;
    }
  }

  function f(a) {
    var b = j.now();

    try {
      localStorage.setItem(d(a), b);
    } catch (c) {}
  }

  function g(a) {
    var b = null,
        c = d(a);

    try {
      b = localStorage.getItem(c), localStorage.removeItem(c);
    } catch (e) {}

    var f = 0;
    return b && (f = j.now() - b), f;
  }

  function h(a) {
    try {
      var b = d(a);
      localStorage.removeItem(b);
    } catch (c) {}
  }

  var i = "atatus.com/",
      j = b._helper,
      k = 1,
      l = 0;
  b.beginTransaction = function (a) {
    e() && f(a);
  }, b.endTransaction = function (a) {
    if (e()) {
      var b = g(a);
      c(a, b, k);
    }
  }, b.failTransaction = function (a) {
    if (e()) {
      var b = g(a);
      c(a, b, l);
    }
  }, b.cancelTransaction = function (a) {
    e() && h(a);
  }, b.recordTransaction = function (a, b) {
    e() && a && b && c(a, b, k);
  };
}(window, window.atatus), function (a, b) {
  a._atatusConfig && a._atatusConfig.apikey && b.config(a._atatusConfig.apikey, a._atatusConfig).install();
}(window, window.atatus);